import type { DataTableSorting } from '~shared/ui/data-table';

import { ColumnId } from './columns';

export const defaultPagination = {
  page: 0,
  perPage: 10,
};

export const DEFAULT_SORTING: DataTableSorting = {
  id: ColumnId.DATE,
  direction: 'desc',
};

export const TABLE_MIN_WIDTH = 960;
